import React from 'react'
import { Routes, Route } from 'react-router-dom'
import AdminDashboard from './AdminDashboard'
import AssetManagement from './AssetManagement'
import DocumentRepository from './DocumentRepository'
import SystemSettings from './SystemSettings'
import UserManagement from './UserManagement';
import EnhancedUserManagementWithSidebar from './EnhancedUserManagementWithSidebar';
import AuditLogs from './AuditLogs'
import BackupManagement from './BackupManagement'
import EmployeeAttendanceView from './EmployeeAttendanceView'

const Admin = () => {
  return (
    <div className="p-6">
      <Routes>
        <Route index element={<AdminDashboard />} />
        <Route path="assets" element={<AssetManagement />} />
        <Route path="documents" element={<DocumentRepository />} />
        <Route path="settings" element={<SystemSettings />} />
        <Route path="users" element={<EnhancedUserManagementWithSidebar />} />
        <Route path="users-legacy" element={<UserManagement />} />
        <Route path="users-enhanced" element={<EnhancedUserManagementWithSidebar />} />
        <Route path="audit-logs" element={<AuditLogs />} />
        <Route path="backups" element={<BackupManagement />} />
        <Route path="attendance" element={<EmployeeAttendanceView />} />
      </Routes>
    </div>
  )
}

export default Admin